export default __webpack_public_path__ + "img/clouds.0a775f4e9ccc615580b4e2001055a022.svg";